import { Home } from "./Home";

export function Main() {
  return (
    <main>
      <Home />
    </main>
  );
}
